export * from './thanksgiving-turkey-sub-card';
